import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { EntityDataPubType } from '@/domain/entityBase';
import type { ThunkApiType } from '@/store';
import type { ChildApplyJsonPub, ChildApplyJsonPvt } from '@/types/domain/childApply/entities/childApplyEntity';

import { childApplySlice } from '@/domain/childApply/redux';
import { uiSlice } from '@/domain/ui/redux';
import { api, service } from '@/share';

export const getChildApplyList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'childApply/getChildApplyList',
  async (_, thunkApi) => {
    const { nextTokenChildApply, childApplyList } = thunkApi.getState().childApply;
    const result = await service.childApply.getChildApplyList(nextTokenChildApply);
    const newList = childApplyList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(childApplySlice.actions.setChildApplyList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);

export const refreshChildRemoveList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'childApply/refreshChildRemoveList',
  async (_, thunkApi) => {
    const result = await service.childApply.getChildRemoveList(null);
    thunkApi.dispatch(childApplySlice.actions.setChildRemoveList(result));
  },
);

export const getChildRemoveList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'childApply/getChildRemoveList',
  async (_, thunkApi) => {
    const { nextTokenChildRemove, childRemoveList } = thunkApi.getState().childApply;
    const result = await service.childApply.getChildRemoveList(nextTokenChildRemove);
    const newList = childRemoveList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(childApplySlice.actions.setChildRemoveList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);

export const sendChildApply = createAsyncThunk<
  void,
  EntityDataPubType<ChildApplyJsonPvt, ChildApplyJsonPub>,
  ThunkApiType
>(
  'childApply/sendChildApply',
  async (input, thunkApi) => {
    // 子どもに施設登録
    const { childList, childId } = thunkApi.getState().child;
    const child = childList.find((v) => v.childId === childId);
    if (child) {
      thunkApi.dispatch(uiSlice.actions.startBlocking());
      try {
        await service.child.updateChild(child);
        // 申請を送る
        await service.childApply.sendChildApply(input);
        thunkApi.dispatch(uiSlice.actions.setMessage({
          key: 'info',
          content: '申請しました',
        }));
      } finally {
        thunkApi.dispatch(uiSlice.actions.endBlocking());
      }
    }
  },
);

export const getFacilityList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'childApply/getFacilityList',
  async (_, thunkApi) => {
    const result = await service.childApply.getFacilityList();
    thunkApi.dispatch(childApplySlice.actions.setFacilityList(result));
  },
);

export const getApplyNurseryList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'childApply/getApplyNurseryList',
  async (_, thunkApi) => {
    try {
      const response = await api.wagakoNurseryApi.getNurseryList();
      const items = response.data?.items || [];
      thunkApi.dispatch(childApplySlice.actions.setApplyNurseryList(items));
      if (items.length === 0) {
        thunkApi.dispatch(uiSlice.actions.setMessage({
          key: 'warning',
          content: '申請可能な施設がありません。',
        }));
      }
    } catch (_err) {
      thunkApi.dispatch(childApplySlice.actions.setApplyNurseryList(null));
      thunkApi.dispatch(uiSlice.actions.setMessage({
        key: 'error',
        content: '施設一覧の取得に失敗しました',
      }));
    }
  },
);
